// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"379":"6fedf615","446":"65df7ee0"}[chunkId] + ".css";
};